  <div class=" text-center mb-5 mt-2">
    <h5>{{mls?.languageText?.info?.key1}}<span *ngIf="mls?.is_lskey_display == 1">(info.key1)</span>
    </h5>
    <p innerHTML="{{data?.msg}}"> </p>
  </div>